import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfigService } from '../local/config.service';
import { MessageService } from '../local/message.service';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  protected readonly baseUrl: string;

  constructor(
    private readonly messageService: MessageService,
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {
    this.baseUrl = this.configService.Config.apiUrl;
  }

  public get(): Observable<string | undefined> {
    return this.http
      .get(this.baseUrl + '/version', { responseType: 'text' })
      .pipe(catchError((error) => this.handleError(error)));
  }

  private handleError(error: HttpErrorResponse): Observable<undefined> {
    if (error.status >= 500) {
      this.messageService.error(`version : ${error.statusText}`);
    } else {
      switch (error.status) {
        case 404:
          this.messageService.info(`Introuvable`);
          break;
        default:
          // @ts-ignore
          this.messageService.error(error.title || error.message);
          break;
      }
    }

    return of(undefined);
  }
}
